import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "m-pageCW-nav" }
const _hoisted_2 = { class: "m-pageCW-nav__title" }
const _hoisted_3 = { class: "m-pageCW-nav__title-date" }
const _hoisted_4 = { class: "m-pageCW-nav__title-count" }
const _hoisted_5 = {
  key: 0,
  class: "m-pageCW-nav__action"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/construction-work/archive",
  class: "m-pageCW-nav__archive"
}, "Архив", -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "button-sort" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "button-sort__icon" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "16",
      height: "12",
      viewBox: "0 0 16 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3.46622 0.146447C3.66956 -0.0488155 3.99925 -0.0488155 4.2026 0.146447L7.51631 3.32843C7.71965 3.52369 7.71965 3.84027 7.51631 4.03553C7.31296 4.2308 6.98327 4.2308 6.77993 4.03553L4.35511 1.70711V11.5C4.35511 11.7761 4.12198 12 3.83441 12C3.54683 12 3.31371 11.7761 3.31371 11.5V1.70711L0.888889 4.03553C0.685543 4.2308 0.355855 4.2308 0.152509 4.03553C-0.0508364 3.84027 -0.0508364 3.52369 0.152509 3.32843L3.46622 0.146447Z"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.5338 11.8536C12.3304 12.0488 12.0007 12.0488 11.7974 11.8536L8.48369 8.67157C8.28035 8.47631 8.28035 8.15973 8.48369 7.96447C8.68704 7.7692 9.01673 7.7692 9.22007 7.96447L11.6449 10.2929L11.6449 0.5C11.6449 0.223858 11.878 4.80644e-08 12.1656 5.13573e-08C12.4532 5.46503e-08 12.6863 0.223858 12.6863 0.5L12.6863 10.2929L15.1111 7.96447C15.3145 7.7692 15.6441 7.7692 15.8475 7.96447C16.0508 8.15973 16.0508 8.47631 15.8475 8.67157L12.5338 11.8536Z"
      })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_10 = { class: "button-sort__content" }
const _hoisted_11 = { class: "button-sort__content-header" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "button-sort__content-wrapper" }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemListFilter = _resolveComponent("ItemListFilter")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.dateUser), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.count) + " ", 1 /* TEXT */),
        _createElementVNode("span", null, _toDisplayString(_ctx.formatTextByNumber(_ctx.count, ['работа', 'работы', 'работ'])), 1 /* TEXT */)
      ])
    ]),
    (_ctx.isShowCW)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (!this.isArchive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", null, [
            _createVNode(_component_ItemListFilter, {
              filters: _ctx.filters,
              onApply: _ctx.onItemListFilterApply,
              onReset: _ctx.onItemListFilterReset
            }, null, 8 /* PROPS */, ["filters", "onApply", "onReset"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_Popper, {
              offsetSkid: "0",
              offsetDistance: "0",
              placement: "bottom-end"
            }, {
              content: _withCtx(({ close }) => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createTextVNode(" Сортировка "),
                    _createElementVNode("span", { onClick: close }, null, 8 /* PROPS */, _hoisted_12)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortOptions, (sortOption) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: sortOption.key,
                        class: _normalizeClass(["button-sort__content-item", { active: _ctx.selectedSort === sortOption.key }]),
                        onClick: ($event: any) => (_ctx.onSortClick(sortOption, close))
                      }, _toDisplayString(sortOption.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_14))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}